import { Routes } from '@models/route';
import { lazy } from 'react';

const AnalyticDashboard = lazy(() =>
  import('@pages/analytic/AnalyticDashboard').then((p) => ({ default: p.AnalyticDashboard }))
);
const AnalyticDetail = lazy(() =>
  import('@pages/analytic/AnalyticDetail').then((p) => ({
    default: p.AnalyticDetail
  }))
);

export const AnalyticRoutes: Routes = [
  {
    path: 'admin/analytics-reports',
    component: AnalyticDashboard,
    children: [
      {
        path: ':id',
        component: AnalyticDetail
      }
    ]
  }
];
